module.exports = __webpack_public_path__ + "static/media/whatsapp-text-mock.2331ecf8.jpeg";